<template>
    <div v-if="popUpData && popUpData.showPopUp" :id="idPopUp" class="controls-popup">
        <div class="controls-popup__info">
            <div class="controls-popup__title">
                <div class="controls-popup__title-info">
                    <span class="controls-popup__title-icon">
                        <img v-if="titleIcon != null" :src="titleIcon" />
                    </span>
                    <span class="controls-popup__title-text">{{ popUpTitle }}</span>
                </div>
            </div>
            <div
                class="controls-popup__body"
                :class="{ 'not-current-limit': !showCurrentLimitPopUp }"
            >
                <span
                    v-if="!showChangeModePopUp"
                    class="controls-popup__body-text"
                    v-html="popUpBodyText"
                ></span>
                <ChangeModePopUp v-if="showChangeModePopUp" :pop-up-data="popUpData" />
                <currentLimitPopUp v-if="showCurrentLimitPopUp" :pop-up-data="popUpData" />
                <BatterySocConfirmationPopUp
                    v-if="showBatteryEssPopUp"
                    :pop-up-data="popUpData"
                    @update-confirmed-slider="$emit('update-confirmed-slider', $event)"
                />
                <SwitchConfirmationPopUp v-if="showSwitchPopUp" :pop-up-data="popUpData" />
            </div>
            <div
                class="controls-popup__cancel-confirm"
                :class="{ 'not-current-limit': !showCurrentLimitPopUp }"
            >
                <div
                    class="controls-popup__cancel-button"
                    :class="{ 'battery-soc': showBatteryEssPopUp }"
                    @click="handleCancel()"
                >
                    <span class="controls-popup__cancel-text">
                        {{ this.$t('common.cancel', { i18nFallback: 'Cancel' }) }}
                    </span>
                </div>
                <div
                    class="controls-popup__confirm-button"
                    :class="{ 'battery-soc': showBatteryEssPopUp }"
                    @click="handleConfirm()"
                >
                    <span class="controls-popup__confirm-text">
                        {{ this.$t('common.confirm', { i18nFallback: 'Confirm' }) }}
                    </span>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { Vue, Component, Prop, Watch } from 'vue-property-decorator';
import currentLimitPopUp from './currentLimitPopUp.vue';
import ChangeModePopUp from './ChangeModePopUp.vue';
import BatterySocConfirmationPopUp from './BatterySocConfirmationPopUp.vue';
import SwitchConfirmationPopUp from './SwitchConfirmationPopUp.vue';
import { ngInject } from '@/vue/decorators/angular-interop';

@Component({
    components: {
        BatterySocConfirmationPopUp,
        currentLimitPopUp,
        ChangeModePopUp,
        SwitchConfirmationPopUp,
    },
})
export default class controlsConfirmationMobilePopUp extends Vue {
    @Prop({ default: () => ({}) })
    popUpData;
    @ngInject()
    AppearanceService;
    currentValue = this.popUpData && this.popUpData.acLimits[this.popUpData.acInputIdx];
    initialLimit = null;
    tempMinSoc = '';

    @Watch('popUpData.showPopUp', { immediate: true })
    onShowPopUpChanged(newVal) {
        if (newVal && this.popUpData && this.popUpData.acLimits) {
            // Store initial value when popup opens
            this.initialLimit = this.popUpData.acLimits[this.popUpData.acInputIdx];
        }
    }

    handleCancel() {
        // Reset to initial value using Vue.set
        if (this.initialLimit !== null) {
            this.$set(
                this.popUpData && this.popUpData.acLimits,
                this.popUpData.acInputIdx,
                this.initialLimit,
            );
        }
        this.handleClose();
    }

    get popUpTitle() {
        switch (this.popUpData.popUpType) {
            case 'CHARGING-STATION':
            case 'INVERTER':
                return this.$t('dashboard.ev_charging.mode', { i18nFallback: 'Mode' });
            case 'ESS':
            case 'AC-ESS':
                return 'ESS'; //You can't translate ESS?
            case 'INVERTER-GRID-LIMIT':
            case 'AC-SYSTEM-GRID-LIMIT':
                return this.$t('dashboard.input_current_limit', {
                    i18nFallback: 'Input current limit',
                });
            case 'ESS-BATTERY':
                return this.$t('dashboard.dci.ess_battery_soc', { i18nFallback: 'Battery SOC' });
            case 'CHARGING-STATION-CURRENT':
                return this.$t('dashboard.ev_charging.current', { i18nFallback: 'Charge current' });
            default:
                return '';
        }
    }

    get titleIcon() {
        if (this.AppearanceService.isDarkModeActive()) {
            switch (this.popUpData.popUpType) {
                case 'ESS':
                case 'AC-ESS':
                    return '/img/svg-icons/Battery-ess-logo-white.svg';
                default:
                    return '';
            }
        } else {
            switch (this.popUpData.popUpType) {
                case 'ESS':
                case 'AC-ESS':
                    return '/img/svg-icons/Battery-ess-logo-black.svg';
                default:
                    return '';
            }
        }
    }
    handleClose() {
        this.$emit('updateShowPopUp', {
            showPopUp: false,
        });
    }

    handleConfirm() {
        // Determine the value to assign
        const confirmedValue = this.popUpData.current
            ? this.popUpData.current
            : this.popUpData.acLimits && this.popUpData.acLimits[this.popUpData.acInputIdx]
            ? [this.popUpData.acLimits[this.popUpData.acInputIdx], this.popUpData.acInputIdx]
            : null;

        // Store confirmed input limit
        this.$set(this.popUpData, 'confirmedInputCurrentLimit', confirmedValue);

        this.$emit('confirmedChoice', this.popUpData);
        this.handleClose();
    }

    setInputValue(num) {
        this.$set(this.popUpData && this.popUpData.acLimits, this.popUpData.acInputIdx, num);
    }

    get computedCurrentValue() {
        return this.popUpData && this.popUpData.acLimits[this.popUpData.acInputIdx];
    }

    onChange(values) {
        this.tempMinSoc = values;
    }

    get showCurrentLimitPopUp() {
        return (
            this.popUpData.popUpType === 'INVERTER-GRID-LIMIT' ||
            this.popUpData.popUpType === 'CHARGING-STATION-CURRENT' ||
            this.popUpData.popUpType === 'AC-SYSTEM-GRID-LIMIT'
        );
    }

    get showChangeModePopUp() {
        return (
            this.popUpData.popUpType === 'ESS' ||
            this.popUpData.popUpType === 'INVERTER' ||
            this.popUpData.popUpType === 'CHARGING-STATION' ||
            this.popUpData.popUpType === 'AC-ESS' ||
            this.popUpData.popUpType === 'MULTI-RS' ||
            this.popUpData.popUpType === 'INVERTER-RS' ||
            this.popUpData.popUpType === 'AC-SYSTEM'
        );
    }

    get popUpBodyText() {
        return this.showCurrentLimitPopUp
            ? this.$t('dashboard.adjust_current_limit', {
                  i18nFallback:
                      'Adjust the current by choosing one of the options or enter your desired limit',
              })
            : '';
    }

    get showBatteryEssPopUp() {
        return (
            this.popUpData.popUpType === 'ESS-BATTERY' ||
            this.popUpData.popUpType === 'AC-ESS-BATTERY'
        );
    }

    get showSwitchPopUp() {
        const switchPopUpTypes = [
            'SWITCH-DYNAMIC-ESS',
            'SWITCH-DYNAMIC-AC-ESS',
            'SWITCH-RELAYS',
            'SWITCH-CHARGING-STATION-CHARGE',
            'SWITCH-AUTO-START',
            'SWITCH-TIMED-RUN',
            'SWITCH-MANUAL-START',
            'SWITCH-MANUAL-STOP',
            'SWITCH-RESET-SERVICE',
        ];
        return switchPopUpTypes.includes(this.popUpData.popUpType);
    }

    get idPopUp() {
        switch (true) {
            case this.showBatteryEssPopUp:
                return 'battery-soc';
            case this.showSwitchPopUp || this.showChangeModePopUp:
                return 'change-mode';
            case this.showCurrentLimitPopUp:
                return 'input-current-limit';
        }
        return '';
    }
}
</script>
